import classNames from 'classnames/bind';
import React, { useMemo } from 'react';

import { TreeNodeModel, TreeSelect } from '@creditsights/styleguide-web';
import styles from './FilterSideBarItemOpen.module.scss';

const cx = classNames.bind(styles);

interface FilterProps {
  data: TreeNodeModel[];
  placeholder: string;
  dataTestId?: string;
  onChange: (checkedKeys: string[]) => void;
  checkedKeys: string[];
}

const getFilterKeys = (data: TreeNodeModel): string[] => {
  if (!data.children) {
    return [data.key];
  }
  const childrenTagIds = data.children.flatMap((node) => getFilterKeys(node));
  return [data.key, ...childrenTagIds];
};

const FilterSideBar = ({ data, placeholder, dataTestId, onChange, checkedKeys }: FilterProps): React.ReactElement => {
  const dataKeys = data.flatMap((filter) => getFilterKeys(filter));
  const validSelectedFilterKeys = Array.from(new Set(checkedKeys.filter((key) => dataKeys.includes(key))));

  const renderOption = (placeholder: string) => (
    <span>
      <span data-testid="filter-tree-selected-placeholder">{placeholder}</span>
    </span>
  );

  const buttonTriggerDisplayValue = useMemo(() => renderOption(placeholder), [validSelectedFilterKeys]);

  const renderFilterName = () => {
    return (
      <div className={cx('filter-name')} data-testid="filter-name">
        {buttonTriggerDisplayValue}
      </div>
    );
  };

  return (
    <div className={cx('body')} data-testid={dataTestId}>
      {renderFilterName()}
      <TreeSelect
        data={data}
        showReset={false}
        treeHeight={180}
        checkedKeys={validSelectedFilterKeys}
        setCheckedKeys={(validCheckedKeys) => {
          onChange(validCheckedKeys);
        }}
      />
    </div>
  );
};

export default FilterSideBar;
